<template lang="pug">
  .two-columns-list(:class="{'--list': view === 'list'}")
    slot(name="title")

    .two-columns-list__body
      slot(name="empty" v-if="!tournaments.length")

      .two-columns-list__body-inner(v-else)
        template(v-for="(item, index) in list")
          Component(:is="cardComponent" :key="item.id + ' ' +  index" :tournament="item" :view="view" :is-small="isSmall")

</template>

<script>
import PhasedTournamentCard from '~/components/PhasedTournamentCard/PhasedTournamentCard'

export default {
  name: 'TwoColumnsList',

  components: {
    PhasedTournamentCard
  },

  props: {
    cardComponent: {
      type: String,
      default: 'PhasedTournamentCard'
    },

    tournaments: {
      type: Array,
      required: true
    },

    view: {
      type: String,
      default: 'cells'
    },

    isSmall: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    list () {
      return this.tournaments
    }
  }
}
</script>

<style lang="scss">
.two-columns-list {
  &__body {
    width: 100%;

    &-inner {
      width: 100%;
      display: grid;
      column-gap: 32px;
      row-gap: 32px;
      grid-template-columns: 1fr 1fr;
      margin-top: 32px;

      @media (max-width: $breakpointDesktop) {
        margin-top: 24px;
      }

      @media (max-width: $breakpointTablet) {
        display: block;

        .phased-tournament-card {
          margin-bottom: 16px;
        }
      }
    }
  }

  &.--list {
    .two-columns-list__body {
      &-inner {
        display: block;
      }
    }
  }
}
</style>
